import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './Pages/Login';
import Productos from './Pages/Productos';
import Ventas from './Pages/Ventas';
import VentasMobile from './Pages/VentasMobile';
import Categorias from './Pages/Categorias';
import Soporte from './Pages/Soporte';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentPage, setCurrentPage] = useState('productos');

  // Check authentication status and URL routing on component mount
  useEffect(() => {
    const authStatus = localStorage.getItem('isAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
    
    // Auto-route based on URL
    const path = window.location.pathname.replace(/^\/|\/$/g, ''); // strip slashes
    const searchParams = new URLSearchParams(window.location.search);
    
    if (path === 'ventas-mobile' || searchParams.get('view') === 'ventas-mobile' || window.location.hash.includes('ventas-mobile')) {
      setCurrentPage('ventas-mobile');
    }
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('username');
    localStorage.removeItem('userId');
    setIsAuthenticated(false);
    setCurrentPage('productos');
  };

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'productos':
        return <Productos onMenuSelect={setCurrentPage} onLogout={handleLogout} />;
      case 'ventas':
        return <Ventas onMenuSelect={setCurrentPage} onLogout={handleLogout} />;
      case 'ventas-mobile':
        return <VentasMobile onMenuSelect={setCurrentPage} onLogout={handleLogout} />;
      case 'categorias':
        return <Categorias onMenuSelect={setCurrentPage} onLogout={handleLogout} />;
      case 'soporte':
        return <Soporte onMenuSelect={setCurrentPage} onLogout={handleLogout} />;
      default:
        return <Productos onMenuSelect={setCurrentPage} onLogout={handleLogout} />;
    }
  };

  // Show Login screen if not authenticated
  if (!isAuthenticated) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div className="App">
      {renderCurrentPage()}
    </div>
  );
}

export default App;